<template>
  <div>
    <RessourceInfoBulle code="DE-TITRE" />
    <RessourceInfoBulle code="DE-SOUS-TITRE" />
    <RessourceInfoBulle code="DE-TEXTE" />
  </div>
</template>

<script>
// Textes configurables du formulaire de démission, communs à la page dédiée et au popup du renouvellement
export default {}
</script>

<style></style>
